import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const connectToPro = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.CONNECT_TO_PRO,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response.data)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
